import React from 'react';
import {Container, Icon} from './SubmitSuccess.styles';
import greenTick from '../../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/assets/green-tick.png';
const SubmitSuccess = ({icon, heading, subHeading}) => {
  return (
    <Container>
      {icon && <Icon src={greenTick} alt="success" />}
      {heading && <h3>{heading}</h3>}
      {subHeading && <p>{subHeading}</p>}
    </Container>
  );
};

export default SubmitSuccess;
